export const CARD_TYPES = [
  { value: 'all',        label: 'All'         },
  { value: 'pokemon',    label: 'Pokemon'     },
  { value: 'magic',      label: 'Magic'       },
  { value: 'yugioh',     label: 'Yu-Gi-Oh!'   },
  { value: 'onepiece',   label: 'One Piece'   },
  { value: 'dragonball', label: 'Dragon Ball' },
  { value: 'digimon',    label: 'Digimon'     },
  { value: 'sports',     label: 'Sports'      },
  { value: 'other',      label: 'Other'       },
] as const;

export type CardTypeValue = (typeof CARD_TYPES)[number]['value'];

interface CardTypeFilterProps {
  active: CardTypeValue | string;
  onChange: (value: CardTypeValue) => void;
  /** 'light' = white pills on a dark hero. 'dark' = normal pills on white bg */
  variant?: 'light' | 'dark';
}

export default function CardTypeFilter({
  active,
  onChange,
  variant = 'dark',
}: CardTypeFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {CARD_TYPES.map((t) => {
        const isActive = active === t.value;
        if (variant === 'light') {
          return (
            <button
              key={t.value}
              type="button"
              onClick={() => onChange(t.value)}
              className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-all ${
                isActive
                  ? 'bg-white text-brand-700 border-white shadow-md'
                  : 'bg-white/20 text-white border-white/40 hover:bg-white/30'
              }`}
            >
              {t.label}
            </button>
          );
        }
        return (
          <button
            key={t.value}
            type="button"
            onClick={() => onChange(t.value)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-all ${
              isActive
                ? 'bg-brand-600 text-white border-brand-600 shadow-sm'
                : 'bg-white dark:bg-zinc-900 text-gray-600 dark:text-zinc-400 border-gray-200 dark:border-zinc-800 hover:border-brand-300 hover:text-brand-600 dark:text-brand-400'
            }`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
